<template>
  <div class="mod_listbox__evaluation">
    <h3 v-if="title">
      <slot></slot>
    </h3>
    <ul class="mod__flex evaluation evaluation__type2">
      <li class="mod__flex__item -w100 -point">
        <i class="evaluation_score posi_0" @click="clickRank(0)" :class="{'evaluation_score__actice':rank==0}"></i>
        <i class="evaluation_score posi_1" @click="clickRank(-3)" :class="{'evaluation_score__actice':rank==-3}"></i>
        <i class="evaluation_score posi_2" @click="clickRank(-2)" :class="{'evaluation_score__actice':rank==-2}"></i>
        <i class="evaluation_score posi_3" @click="clickRank(-1)" :class="{'evaluation_score__actice':rank==-1}"></i>
        <i class="evaluation_score posi_4" @click="clickRank(1)" :class="{'evaluation_score__actice':rank==1}"></i>
        <i class="evaluation_score posi_5" @click="clickRank(2)" :class="{'evaluation_score__actice':rank==2}"></i>
        <i class="evaluation_score posi_6" @click="clickRank(3)" :class="{'evaluation_score__actice':rank==3}"></i>
        <!--        <i class="evaluation_score posi_0" v-if="rank==0"></i>-->
        <!--        <i class="evaluation_score posi_1" v-if="rank==-3"></i>-->
        <!--        <i class="evaluation_score posi_2" v-if="rank==-2"></i>-->
        <!--        <i class="evaluation_score posi_3" v-if="rank==-1"></i>-->
        <!--        <i class="evaluation_score posi_4" v-if="rank==1"></i>-->
        <!--        <i class="evaluation_score posi_5" v-if="rank==2"></i>-->
        <!--        <i class="evaluation_score posi_6" v-if="rank==3"></i>-->
      </li>
      <li class="mod__flex__item -flex" @click="clickRank(-3)">
        3
      </li>
      <li class="mod__flex__item -flex" @click="clickRank(-2)">
        2
      </li>
      <li class="mod__flex__item -flex" @click="clickRank(-1)">
        1
      </li>
      <li class="mod__flex__item -flex" @click="clickRank(0)">
        0
      </li>
      <li class="mod__flex__item -flex" @click="clickRank(1)">
        1
      </li>
      <li class="mod__flex__item -flex" @click="clickRank(2)">
        2
      </li>
      <li class="mod__flex__item -flex" @click="clickRank(3)">
        3
      </li>
      <li class="-low">
        <slot name="low"></slot>
      </li>
      <li class="-high">
        <slot name="high"></slot>
      </li>
    </ul>
  </div>

</template>
<script>
  export default {
    props: {
      rank: {
        default: 0
      },
      title: {
        default: true
      }
    },
    methods: {
      clickRank: function (rank) {
        this.$emit('update:rank', rank)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .mod_listbox .evaluation__type2 {
    text-align: center;
    position: relative;
    padding: 0 24px;
    margin-bottom: 16px;
    color: #ccc;
  }

  .mod__flex {
    display: flex;
    flex-wrap: wrap;

  }

  .mod_listbox .evaluation__type2 .-point {
    border: 1px solid #eee;
    background: #eee;
    height: 4px;
    border-radius: 10px;
    margin-bottom: 8px;
    position: relative;
  }


  .mod_listbox .evaluation__type2 .evaluation_score {
    display: block;
    position: absolute;
    top: 50%;
    margin-top: -8px;
    width: 16px;
    height: 16px;
    border: 1px solid #ccc;
    background: #fff;
    border-radius: 50%;
    margin-left: -8px;

    &.posi_0 {
      left: 50%;
    }

    &.posi_1 {
      left: 7%;
    }

    &.posi_2 {
      left: 21%;
    }

    &.posi_3 {
      left: 35.5%;
    }

    &.posi_4 {
      left: 64%;
    }

    &.posi_5 {
      left: 79%;
    }

    &.posi_6 {
      left: 93%;
    }

  }

  .mod__flex .mod__flex__item.-w100 {
    width: 100%;
  }

  .mod__flex .mod__flex__item.-flex {
    -ms-flex: 1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
  }

  .mod__flex .mod__flex__item {
    width: 100%;
  }

  .mod_listbox .evaluation__type2 .evaluation_score__actice {
    border: 1px solid #5553CF;
    background: #5553CF;
  }

  .mod_listbox .evaluation__type2 .-high {
    position: absolute;
    right: 0;
    bottom: 0;
    color: #5553CF;
  }

  .mod_listbox .evaluation__type2 .-low {
    position: absolute;
    left: 0;
    bottom: 0;
    color: #5553CF;
  }
</style>



// WEBPACK FOOTER //
// EvaluationType2.vue?f8881514